'use client';

import { use } from 'react';

import { DialogFormContext } from '../context/dialog-form-context';

export const useDialogFormContext = () => {
   const {
      customerFeedback = {
         category: undefined,
         feedback: undefined
      },
      setFeedback = () => {}
   } = use(DialogFormContext) ?? {};

   return { setFeedback, customerFeedback };
};
